/* UTB — injecteert per-bullet SVG-iconen in de Firmhouse
   Subscribe & Save card. Mirror pattern van restore-probiotics-bullets.js,
   met body-class scope op utb + utb-specifieke NL bullets.
   Alleen actief op product-handle--clear-out-patches-with-salicylic-acid. */
(function () {
  if (!document.body.classList.contains('product-handle--clear-out-patches-with-salicylic-acid')) return;

  var ICONS = {
    leaf:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/>' +
      '<path d="M2 21c0-3 1.85-5.36 5.08-6"/>' +
      '</svg>',
    refreshCw:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>' +
      '<path d="M21 3v5h-5"/>' +
      '<path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>' +
      '<path d="M3 21v-5h5"/>' +
      '</svg>',
    shieldCheck:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>' +
      '<path d="m9 12 2 2 4-4"/>' +
      '</svg>',
    stethoscope:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M11 2v2"/>' +
      '<path d="M5 2v2"/>' +
      '<path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1"/>' +
      '<path d="M8 15a6 6 0 0 0 12 0v-3"/>' +
      '<circle cx="20" cy="10" r="2"/>' +
      '</svg>',
    users:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>' +
      '<circle cx="9" cy="7" r="4"/>' +
      '<path d="M22 21v-2a4 4 0 0 0-3-3.87"/>' +
      '<path d="M16 3.13a4 4 0 0 1 0 7.75"/>' +
      '</svg>'
  };

  // Mirror van restore-probiotics-bullets.js — exact dezelfde Engelse
  // tekst zodat Shopify's translation-layer alle 4 PDP's identiek vertaalt.
  var BULLETS = [
    { icon: ICONS.users,       text: 'Trusted by 30,000+ women' },
    { icon: ICONS.shieldCheck, text: '60-day money-back guarantee' },
    { icon: ICONS.refreshCw,   text: 'Flexible subscription, cancel anytime' }
  ];

  var BULLETS_HASH = BULLETS.map(function (b) { return b.text; }).join('|');

  var TARGET_SELECTOR = '.selling_plan_app_container li.subscription-card .card-content';
  var ROOT_SELECTOR   = '.selling_plan_app_container';
  var INJECTED_FLAG   = 'data-solvey-injected';

  function buildList() {
    var ul = document.createElement('ul');
    ul.className = 'solvey-sub-bullets';
    ul.setAttribute(INJECTED_FLAG, 'true');
    ul.dataset.bulletsHash = BULLETS_HASH;
    BULLETS.forEach(function (b) {
      var li = document.createElement('li');
      li.innerHTML = b.icon + '<span>' + b.text + '</span>';
      ul.appendChild(li);
    });
    return ul;
  }

  function inject() {
    var targets = document.querySelectorAll(TARGET_SELECTOR);
    for (var i = 0; i < targets.length; i++) {
      var existing = targets[i].querySelector('.solvey-sub-bullets[' + INJECTED_FLAG + '="true"]');
      if (existing) {
        if (existing.dataset.bulletsHash === BULLETS_HASH) continue;
        existing.parentNode.removeChild(existing);
      }
      targets[i].appendChild(buildList());
    }
  }

  // Verwijder de NL/EN-frequency-labels uit de Firmhouse-cards:
  // "elke", "each", "per stuk", "per piece". Loopt door tekst-nodes
  // binnen .selling_plan_app_container en filtert die strings eruit.
  function cleanLabels() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var r = 0; r < roots.length; r++) {
      var walker = document.createTreeWalker(roots[r], NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var orig = node.nodeValue;
        if (!orig || !/(per\s+stuk|per\s+piece|\belke\b|\beach\b)/i.test(orig)) continue;
        var updated = orig
          .replace(/\s*\bper\s+stuk\b\.?/gi, '')
          .replace(/\s*\bper\s+piece\b\.?/gi, '')
          .replace(/\b(elke|each)\s+/gi, '')
          .replace(/\b(elke|each)\b/gi, '')
          .replace(/\s{2,}/g, ' ')
          .replace(/\s+([.,;:!?])/g, '$1')
          .replace(/^[\s\/|·•·]+|[\s\/|·•·]+$/g, '');
        if (updated !== orig) node.nodeValue = updated;
      }
    }
  }

  function applyAll() {
    inject();
    cleanLabels();
  }

  function start() {
    applyAll();
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root || !('MutationObserver' in window)) return;

    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyAll, 50);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Firmhouse rendert soms ná DOMContentLoaded; retry kort.
  var retries = 0;
  var retryTimer = setInterval(function () {
    retries++;
    var existing = document.querySelector(TARGET_SELECTOR + ' .solvey-sub-bullets[' + INJECTED_FLAG + '="true"]');
    if ((existing && existing.dataset.bulletsHash === BULLETS_HASH) || retries > 20) {
      clearInterval(retryTimer);
      return;
    }
    applyAll();
  }, 250);
})();
